import PrimaryNav from './PrimaryNav';

export { type PrimaryNavProps } from './PrimaryNav';
export default PrimaryNav;
